export * from "./customer-list-data-view/customer-list-data-view.component";